import { Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { RequireSession } from '../auth/RequireSession';
import { useSession } from '../auth/SessionContext';
import { usePermissions } from '../auth/usePermissions';
import { useT } from '../i18n/LanguageContext';

import { AppLayout } from './AppLayout';
import { businessNavigation } from './businessNavigation';

export const BusinessShell = () => {
  const { profile, signOut } = useSession();
  const permissions = usePermissions();
  const navigate = useNavigate();
  const t = useT();
  const user = profile?.kind === 'business' ? profile.user : null;

  return (
    <RequireSession kind="business">
      <AppLayout
        navigation={businessNavigation(permissions)}
        context={
          user ? (
            <Chip
              size="small"
              color="primary"
              variant="outlined"
              label={user.tenant.name}
              sx={{ ml: 1, display: { xs: 'none', sm: 'inline-flex' } }}
            />
          ) : null
        }
        identity={
          user
            ? {
                primary: user.displayName ?? user.email,
                secondary: t(user.isOwner ? 'role.owner' : 'role.subUser'),
              }
            : undefined
        }
        onSignOut={() => void signOut().then(() => navigate('/login'))}
      />
    </RequireSession>
  );
};
